import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Breadcrumb = ({ paths }) => (
  <S.Container>
    {paths.map(path => (
      <S.PathLink
        key={path.pathTo}
        to={`${path.pathTo.includes('/') ? path.pathTo : `/${path.pathTo}`}`}
      >
        {path.textPath}
      </S.PathLink>
    ))}
  </S.Container>
);

export default Breadcrumb;

Breadcrumb.propTypes = {
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      textPath: PropTypes,
      pathTo: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};
